
export default function Statement () {
  return (
    <section className='topSection'>
      <section className='descriptionContainer'>
        <p className=''>I am a multi-discipline engineer and a Project Management Professional with 9+ years experience in predictive and agile methodologies. While I was working for the City of New York, I was able to use my problem solving and organizational skills to develop a highly successful career as both a Civil Engineer and a Project Manager. Building on my general interest in computers and technology, I began my interest in coding during the lockdown phase of the covid pandemic, became more interested in continuing to learn and began self-teaching. This ultimately led me to realize that I wanted to become a software engineer, and I am ready to continue my journey recently graduated from General Assembly's Software Engineering Immersive program.</p>
      </section>
    </section>
  )
}
